import Main from './Main'
import User from './User'
import Group from './Group'
import Settings from './Settings'
import Application from './Application'
import Billing from './Billing'
import Revenue from './Revenue'

export default {
  Main,
  User,
  Group,
  Settings,
  Application,
  Billing,
  Revenue
}



// WEBPACK FOOTER //
// ./src/components/Community/index.js